import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { payloadToProjectAssetsResponse } from '../mappers/payloadToProjectAssets';
import { ProjectAssetsResponseModel } from '../model/projectModel';
import { PayloadProjectAssetsResponseModel } from '../model/projectPayloadModel';

const getUrl = ({
  host,
  projectId,
  pageNumber,
  pageSize,
  search,
}: {
  host: string;
  projectId: string;
  pageNumber: number;
  pageSize: number;
  search?: string;
}): string => {
  const params = new URLSearchParams();
  pageNumber && params.append('page[number]', String(pageNumber));
  pageSize && params.append('page[size]', String(pageSize));
  !!search && params.append('search', search);

  return `${host}/projects/${projectId}/assets?${params}`;
};

export const GetAssetsListByProjectId = async ({
  host,
  token,
  projectId,
  pageNumber,
  pageSize,
  search,
}: {
  host: string;
  token: string;
  projectId: string;
  pageNumber: number;
  pageSize: number;
  search?: string;
}): Promise<ProjectAssetsResponseModel> => {
  try {
    const url = getUrl({ host, projectId, pageNumber, pageSize, search });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 30000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<PayloadProjectAssetsResponseModel>;
    return payloadToProjectAssetsResponse(data);
  } catch (error) {
    throw getErrorFormat(error);
  }
};
